import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import LoginHeader from "./components/LoginHeader.js";
import SideNavigation from "./components/SideNavigation.js";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import WestIcon from "@mui/icons-material/West";
import EastIcon from "@mui/icons-material/East";
import MaterialityPopup from "./MaterialityPopup.js";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import MaterialityTabs from "./MaterialityTabs.js";
import { useNavigate } from "react-router-dom";
import { BlobServiceClient } from "@azure/storage-blob";
import csrdData from "./csrdData";
import AADHeader from "./components/AADHeader.js";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import { getSavedReportName } from "./utils/getSavedReportName.js";

const steps = ["Start", "Materiality", "Module", "Input", "Report"];

export default function Materiality() {
  const username = localStorage.getItem("userName");
  const companyid = localStorage.getItem("companyid");
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768);
  const [isModalOpen, setIsModalOpen] = useState(() => localStorage.getItem("popup1") === "true");
  const [loading, setLoading] = useState(false);
  const [savedReports, setSavedReports] = useState([]);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [formData, setFormData] = useState({
    selectedCheckboxes: [],
  });
  const [selectedCheckboxes1, setSelectedCheckboxes1] = useState([]);
  const [openCheckboxDialog, setOpenCheckboxDialog] = useState(false);
  const savedReportName = getSavedReportName();

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false); // Close sidebar on mobile
      } else {
        setIsSidebarOpen(true); // Open sidebar on larger screens
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleFormChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleCheckboxChange = (selectedCheckboxes) => {
    setSelectedCheckboxes(selectedCheckboxes);
  };

  async function uploadJsonFile(containerName, folderName, fileName, jsonData) {
    try {
      // Fetch SAS token from your API
      let res = await fetch(`${process.env.REACT_APP_BASE_API_URL}GetSASToken`, {
        method: "GET",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      });

      if (res.status === 200) {
        const responseJson = await res.json();
        const connectionString = responseJson.data;

        // Create BlobServiceClient using the SAS token
        const blobServiceClient = new BlobServiceClient(connectionString);

        // Get or create container
        const containerClient = blobServiceClient.getContainerClient(containerName);

        //await containerClient.createIfNotExists();

        // Get BlobClient for the file
        const blobName = `${folderName}/${fileName}.json`; // Construct blob name with folder path
        const blobClient = containerClient.getBlobClient(blobName);
        const blockBlobClient = blobClient.getBlockBlobClient();
        console.log(blobClient);
        // Convert JSON data to ArrayBuffer
        const arrayBuffer = new TextEncoder().encode(JSON.stringify(jsonData));
        // Upload the file content
        const uploadResponse = await blockBlobClient.uploadBrowserData(arrayBuffer.buffer, {
          blobHTTPHeaders: { blobContentType: "application/json" }, // Set content type as JSON
          blockSize: 4 * 1024 * 1024, // 4MB block size
          concurrency: 20, // Number of concurrent requests
          onProgress: (ev) => console.log(ev.loadedBytes),
        });
        if (uploadResponse) {
          console.log(`JSON file "${fileName}" uploaded successfully.`);
          console.log(`Blob URL: ${blobClient.url}`);
        }
        // Perform any additional operations after successful upload
        // uploadFileName(fileName); // Assuming this is some function you want to call after upload
      } else {
        console.error("Failed to fetch SAS token.");
      }
    } catch (error) {
      console.error("Error uploading JSON file:", error);
    }
  }

  const validateCheckboxSelection = () => {
    const step2Storage = localStorage.getItem("step2Draft") || localStorage.getItem("step2");
    const step2 = step2Storage ? JSON.parse(step2Storage) : [];

    // Check if at least one valid checkbox exists in draft/persisted data
    const hasSelectedCheckboxes = Array.isArray(step2) && step2.some((item) => item && item.panelId);

    if (!hasSelectedCheckboxes) {
      setOpenCheckboxDialog(true);
      return false;
    }
    return true;
  };

  const prepareMaterialityData = () => {
    const step1 = localStorage.getItem("step1");
    const step2Draft = JSON.parse(localStorage.getItem("step2Draft") || localStorage.getItem("step2") || "[]");
    const step2 = Array.isArray(step2Draft) ? step2Draft.filter((x) => x && x.panelId) : [];
    localStorage.setItem("step2", JSON.stringify(step2));
    localStorage.removeItem("step2Draft");

    // Build modules implied by materiality and merge with existing step3 (do not overwrite user-selected modules)
    const selectedPanelIds = new Set(step2.map((x) => x.panelId).filter(Boolean));
    selectedPanelIds.add("general1");
    const materialityModules = [];
    csrdData.forEach((tab, tabIndex) => {
      (tab.accordionPanels || []).forEach((panel, panelIndex) => {
        if (!panel || !selectedPanelIds.has(panel.id)) return;
        (panel.checkboxes || []).forEach((checkbox, checkboxIndex) => {
          materialityModules.push({
            tabIndex,
            panelIndex,
            checkboxIndex,
            label: checkbox?.label || "",
            panelId: panel.id,
          });
        });
      });
    });

    const existingStep3 = JSON.parse(localStorage.getItem("step3") || "[]");
    const mergedArray = [...existingStep3, ...materialityModules];
    const distinctArray = mergedArray.reduce((acc, current) => {
      const exists = acc.find((item) => item.tabIndex === current.tabIndex && item.panelIndex === current.panelIndex && item.checkboxIndex === current.checkboxIndex);
      return exists ? acc : acc.concat([current]);
    }, []);
    localStorage.setItem("step3", JSON.stringify(distinctArray));

    const hash = localStorage.getItem("hash");
    const data = JSON.parse(step1);
    const rdata = {
      name: data.name,
      timeline: data.timeline,
      legalEntity: data.legalEntity,
      startDate: data.startDate,
      endDate: data.endDate,
      materiality: step2,
      reportingModule: distinctArray,
    };
    uploadJsonFile("ecoprismfilecontainer", companyid, hash, rdata);
  };

  const handleSave = () => {
    if (!validateCheckboxSelection()) {
      return;
    }

    prepareMaterialityData();
    navigate("/ReportingModules");
  };

  const prepareStatusDashboardContext = () => {
    const step1 = localStorage.getItem("step1");
    if (!step1) return;
    const parsed = JSON.parse(step1);
    const reportName = parsed?.name || "Untitled Report";
    const completionDate = parsed?.timeline1 || parsed?.timeline || "";
    localStorage.setItem("reportStatusData", JSON.stringify({ reportName, completionDate }));
    const hash = localStorage.getItem("hash") || "";
    const statusFile = hash ? `${hash}.json` : "";
    localStorage.setItem("statusReportFile", statusFile);
    localStorage.setItem("statusDashboardUrl", `/reportdashboard?file=${encodeURIComponent(statusFile)}`);
  };

  // useEffect(() => {
  //   // Open the modal on page load
  //   setIsModalOpen(true);
  // }, []);
  const renderHeader = () => {
    const loginType = localStorage.getItem("loginType");
    if (loginType === "AAD") {
      return <AADHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />;
    }
    return <LoginHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />;
  };
  return (
    <div id="wrapper">
      <div>
        {loading && (
          <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </div>
      {renderHeader()}
      <SideNavigation isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div id="page-content-wrapper" className={isSidebarOpen ? "page-content-wrapper-pd-0" : "page-wrapper"}>
        <div className="container formpd">
          <div className="">
            <div className="row">
              <div className="steps__containt-hader col-md-6">
                <h3 className="title">Select Materiality Topics</h3>
                <div role="presentation">
                  <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                    <Link underline="hover" color="inherit" href="/standards">
                      Reports
                    </Link>
                    <Link underline="hover" color="inherit" href="/standards">
                      Standards & Frameworks
                    </Link>
                    <Link underline="hover" color="inherit" href="/csrd">
                      CSRD
                    </Link>
                    <Typography color="text.primary">{savedReportName}</Typography>
                  </Breadcrumbs>
                </div>
              </div>
              <div className="stepper-box col-md-6">
                <Stepper activeStep={1} alternativeLabel className="csrd-stepper">
                  {steps.map((label) => (
                    <Step key={label}>
                      <StepLabel className="step-name">{label}</StepLabel>
                    </Step>
                  ))}
                </Stepper>
              </div>
            </div>
          </div>
          <div>
            <div className="button-box d-flex justify-content-end">
              <Button onClick={() => navigate("/csrd")} variant="outlined" className="module-btn" size="medium" sx={{ marginRight: "15px" }}>
                <WestIcon fontSize="small" sx={{ marginRight: "4px" }} />
                Start
              </Button>
              <Button onClick={prepareStatusDashboardContext} variant="outlined" className="module-btn" size="medium" sx={{ marginRight: "15px" }} disabled>
                <img src="/assets/img/reports/Status.svg" style={{ marginRight: "4px" }} />
                Status
              </Button>
              <Button onClick={() => {
                if (!validateCheckboxSelection()) {
                  return;
                }
                prepareMaterialityData();
                navigate("/ReportingModules");
              }} variant="outlined" className="module-btn" size="medium">
                Module <EastIcon fontSize="small" sx={{ marginLeft: "4px" }} />
              </Button>
            </div>
            <MaterialityTabs />
            <div className="row justify-content-end pt-3">
              <div className="col-auto">
                <Button variant="outlined" className="outline-btn" size="medium" type="button" onClick={() => navigate("/csrd")}>
                  Previous
                </Button>
              </div>
              <div className="col-auto">
                <Button onClick={handleSave} className="next-button" variant="contained" size="medium">
                  Save
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <MaterialityPopup isModalOpen={isModalOpen} onClose={closeModal} />

      {/* Dialog for checkbox validation warning */}
      <Dialog
        open={openCheckboxDialog}
        onClose={() => setOpenCheckboxDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            borderRadius: "16px",
            padding: "20px",
            minWidth: "400px",
            textAlign: "center",
          },
        }}
      >
        <DialogContent sx={{ paddingTop: "20px", paddingBottom: "10px" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <img src="assets/img/error.png" alt="Error" style={{ width: "55px", height: "55px" }} />
            <Typography variant="h5" component="div" sx={{ fontWeight: 600, color: "#407775" }}>
              Error!
            </Typography>
            <DialogContentText
              id="alert-dialog-description"
              sx={{
                fontSize: "16px",
                color: "#666",
                marginBottom: "10px",
              }}
            >
              Please select at least one or more checkboxes before proceeding.
            </DialogContentText>
          </div>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", paddingBottom: "20px" }}>
          <Button
            onClick={() => setOpenCheckboxDialog(false)}
            variant="contained"
            autoFocus
            sx={{
              backgroundColor: "#407775",
              color: "white",
              padding: "10px 40px",
              fontSize: "16px",
              fontFamily: "Poppins, sans-serif",
              textTransform: "none",
              borderRadius: "8px",
              "&:hover": {
                backgroundColor: "#356663",
              },
            }}
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
